export default "__VITE_ASSET__aD3A7XLu__"